import { render, staticRenderFns } from "./resumenTotal.vue?vue&type=template&id=0a465f7b"
import script from "./resumenTotal.vue?vue&type=script&lang=js"
export * from "./resumenTotal.vue?vue&type=script&lang=js"
import style0 from "./resumenTotal.vue?vue&type=style&index=0&id=0a465f7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports